import { render, staticRenderFns } from "./instockTendency.vue?vue&type=template&id=4a85b240&scoped=true&"
import script from "./instockTendency.vue?vue&type=script&lang=js&"
export * from "./instockTendency.vue?vue&type=script&lang=js&"
import style0 from "./instockTendency.vue?vue&type=style&index=0&id=4a85b240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a85b240",
  null
  
)

export default component.exports